// Lib
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import OrderHistory from '../../../components/OrderHistory';
import Spinner from '../../../components/Spinner';

// Actions
import { GetRecurringOrders } from '../../../actions/orders';

// Hooks
import useSearch from '../../../hooks/useSearch';
import Error from '../../../components/Error';

const RecurringOrdersPage = ({ orders }) => {
  const dispatch = useDispatch();
  const { onClearSearch } = useSearch();
  const { isLoading, apiError } = useSelector((state) => ({
    isLoading: state.isLoading,
    apiError: state.apiError?.['getRecurringOrders'],
  }));

  useEffect(() => {
    dispatch(GetRecurringOrders());

    return () => {
      onClearSearch();
    };
  }, [dispatch, onClearSearch]);

  if (isLoading) {
    return <Spinner />;
  }

  if (apiError) {
    return <Error message={apiError} />;
  }

  return <OrderHistory isRecurring orders={orders} />;
};

export default RecurringOrdersPage;
